const UserStatus = {

    // FIELDS
    "premise": 'Premise',
    "role": 'Role',
    "status": 'Status',

    // STATUS OPTIONS
    "status_active": 'Active',
    "status_inactive": 'Inactive',

    // BUTTON
    "generate": 'Generate',

    // TOAST
    "success": 'Generated Successfully',

    // TOOLTIP
    "preview": 'Preview',

    // PAGE HEADER
    "user_status_report": 'User Status Report',

    // ERROR
    "error_premise": 'Select Premise',
    "error_role": 'Select Role',
    "error_status": 'Select Status',

    // TABLE HEADER
    "table_premise": 'PREMISE',
    "table_role": 'ROLE',
    "table_status": 'STATUS',
    "table_generated_d&t": 'GENERATED D&T',
}

export default UserStatus;